import React from 'react';

import classNames from 'classnames';
import noop from 'lodash/noop';
import { BringgFontIcons, BringgIcon } from '@bringg/bringg-icons';

interface Props {
	onClick: () => void;
	className?: string;
	disabled?: boolean;
}

const TrashButton: React.FC<Props> = ({ onClick, className, disabled }) => {
	return (
		<span className={classNames('trash-button', className, { disabled })} onClick={disabled ? noop : onClick}>
			<BringgIcon iconName={BringgFontIcons.Trash} />
		</span>
	);
};

export default TrashButton;
